export default __webpack_public_path__ + "static/media/PepperyMedium.f7e59bd6.gif";